import styled from 'styled-components'
import { Button, CenterScreenModal } from '../atoms'
import { useErrorHandlerContext, useUserLanguage } from '@/customHooks'
import { Col, Row } from 'react-grid-system'
import { GraphQLErrors } from '@apollo/client/errors'

const textsData = {
  en: {
    title: 'A Problem Ocurred',
    description: 'A problem Ocurred, please try again',
    confirmButton: 'Continue',
    messageLabel: 'Error Message'
  },
  es: {
    title: 'Ocurrió un problema',
    description: 'Ocurrió un problema, por favor intente de nuevo',
    confirmButton: 'Continuar',
    messageLabel: 'Mensaje de Error'
  }

}
const Wrapper = styled.div`
  margin: 0 auto;
  padding: 20px;
  width: 80%;
`

const TextContainer = styled(Row)`
  padding-bottom: 4rem;
  & h1 {
    font-size: ${({ theme }) => theme.typography.fontSize.s4};
  }
`

const StyledButton = styled(Button)`
  font-weight: 300;
`

const ErrorMessageContainer = styled(Col)`
  border: solid 1px rgb(240, 20, 40);
  border-radius: ${({theme}) => theme.border.radius.sm};
  padding: 1rem 2rem;
  background-color: rgba(255, 80, 120, 0.2);
  max-height: 250px;
  overflow: auto;
  color: rgb(240, 20, 40);
`

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const errorHandle = (error: any) => {
    // Manejar errores de red o del servidor
    if (error?.networkError && error?.networkError !== null) {
      console.error('Network error:', error.networkError.message);
      return error.message
    }
    else if (error?.graphQLErrors && error?.graphQLErrors !== null) {
      error.graphQLErrors.forEach((graphQLError: GraphQLErrors[number]) => {
        console.error('GraphQL error:', graphQLError.message);
        if (graphQLError.extensions?.code === 'UNAUTHENTICATED') {
          console.warn('Usuario no autenticado');
        }
      });
      return error.graphQLErrors[0].message
    }
  }

export const ErrorModal = () => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  const { isOpen, error, close } = useErrorHandlerContext();

  return (
    <CenterScreenModal
      isOpen={isOpen}
      onClose={close}
    >
      <Wrapper>
        <TextContainer>
          <Col xs={12}>
            <h1>{texts.title}</h1>
          </Col>
          <Col xs={12}>
            <p>{texts.description}</p>
          </Col>
          <br />
          <Col>
            <p>{`${texts.messageLabel}:`}</p>
          </Col>
          <ErrorMessageContainer xs={12}>
            <code>{errorHandle(error)}</code>
          </ErrorMessageContainer>
        </TextContainer>
        <Row justify="center">
          <Col xs="content">
            <StyledButton
              onClick={close}
            >
              {texts.confirmButton}
            </StyledButton>
          </Col>
        </Row>
      </Wrapper>
    </CenterScreenModal>
  )
}